import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './social-media-publish-params-story-guidelines.module.scss';

export interface StoryGuideline {
  emoji: string;
  text: string;
}

export interface StoryGuidelineProps {
  storyGuideline: StoryGuideline;
}

export function SocialMediaPublishParamsStoryGuideline({storyGuideline}: StoryGuidelineProps): ReactElement<any> {
  const {emoji} = storyGuideline;
  const guideline = storyGuideline.text;

  return (
    <div className={styles.guidelineWrapper}>
      <div className={styles.emojiWrapper}>
        <Text val={emoji} />
      </div>

      <div className={styles.textWrapper}>
        <Text className={styles.guidelineText} size={TextSize.XSMALL} val={guideline} />
      </div>
    </div>
  );
}
